@if (productRegulation) {
  @if (!isMobileView) {
    <div class="container-margin">
      <div class="row">
        <span class="bold xx-large-font">{{
          translationService.getRegulatorInfoText()
        }}</span>
      </div>
      <div class="margin-top-40">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getCanadaDomesticSubstancesListText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(cdslMapping)"
            [columnNameMap]="cdslMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getCepaText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(cepaMapping)"
            [columnNameMap]="cepaMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getCbsaText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(cbsaMapping)"
            [columnNameMap]="cbsaMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>

      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getUsText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(usMapping)"
            [columnNameMap]="usMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>

      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>

      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getDotTdgForProductText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(dotTdgMapping)"
            [columnNameMap]="dotTdgMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getWhmisEachIngredientText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(whmisEachMapping)"
            [columnNameMap]="whmisEachMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getPrecursorText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(precursorMapping)"
            [columnNameMap]="precursorMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getWasteText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(wasteMapping)"
            [columnNameMap]="wasteMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getWhmisClassForProductText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(whmisClassMapping)"
            [columnNameMap]="whmisClassMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getHsText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(hsMapping)"
            [columnNameMap]="hsMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <mat-expansion-panel
        class="clear-panel"
        [togglePosition]="'before'"
        hideToggle="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-title">
              <span class="text-underline">{{
                translationService.getCommentsText()
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-regulation-table
            [productRegulations]="productRegulation"
            [displayedColumns]="getColumnsForTable(commentsMapping)"
            [columnNameMap]="commentsMapping"
          >
          </app-regulation-table>
        </ng-template>
      </mat-expansion-panel>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
    </div>
  } @else {
    <div class="container">
      <mat-toolbar class="row product-name-navbar">
        <span class="bold-600 medium-font">{{ productRegulation.name }}</span>
      </mat-toolbar>
      <div class="info-container-mobile">
        <div class="row margin-top-20">
          <span class="bold x-large-font">{{
            translationService.getRegulatorInfoText()
          }}</span>
        </div>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getCanadaDomesticSubstancesListText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(cdslMapping)"
              [columnNameMap]="cdslMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getCepaText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(cepaMapping)"
              [columnNameMap]="cepaMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getCbsaText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(cbsaMapping)"
              [columnNameMap]="cbsaMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>

        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getUsText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(usMapping)"
              [columnNameMap]="usMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getDotTdgForProductText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(dotTdgMapping)"
              [columnNameMap]="dotTdgMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getWhmisEachIngredientText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(whmisEachMapping)"
              [columnNameMap]="whmisEachMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getPrecursorText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(precursorMapping)"
              [columnNameMap]="precursorMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getWasteText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(wasteMapping)"
              [columnNameMap]="wasteMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getWhmisClassForProductText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(whmisClassMapping)"
              [columnNameMap]="whmisClassMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getHsText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(hsMapping)"
              [columnNameMap]="hsMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
        <mat-expansion-panel
          class="clear-panel"
          [togglePosition]="'before'"
          hideToggle="true"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panel-title">
                <span class="text-underline">{{
                  translationService.getCommentsText()
                }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-template matExpansionPanelContent>
            <app-regulation-table
              [productRegulations]="productRegulation"
              [displayedColumns]="getColumnsForTable(commentsMapping)"
              [columnNameMap]="commentsMapping"
            >
            </app-regulation-table>
          </ng-template>
        </mat-expansion-panel>
        <div class="margin-top-20">
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
  }
}
